import { networkUserTypes as actionTypes } from '@actions';
import { commonState, commonReducer, pagination } from '@dotone/react-ui-core/helpers';

const collectionState = {
  ...commonState.default({ collection: true }),
  pagination,
};

const defaultState = {
  ...commonState.default(),
};

export const networkUserList = (state = collectionState, action) =>
  commonReducer(actionTypes.LIST, state, action);

export const networkUserCreate = (state = defaultState, action) =>
  commonReducer(actionTypes.CREATE, state, action);

export const networkUserUpdate = (state = defaultState, action) =>
  commonReducer(actionTypes.UPDATE, state, action);

export const networkUserDelete = (state = defaultState, action) =>
  commonReducer(actionTypes.DELETE, state, action);
